export var FriendChallengeStatus;
(function (FriendChallengeStatus) {
    FriendChallengeStatus["PENDING"] = "PENDING";
    FriendChallengeStatus["ACTIVE"] = "ACTIVE";
    FriendChallengeStatus["COMPLETED"] = "COMPLETED";
    FriendChallengeStatus["FAILED"] = "FAILED";
    FriendChallengeStatus["CANCELLED"] = "CANCELLED";
})(FriendChallengeStatus || (FriendChallengeStatus = {}));
export var FriendChallengeParticipantStatus;
(function (FriendChallengeParticipantStatus) {
    FriendChallengeParticipantStatus["INVITED"] = "INVITED";
    FriendChallengeParticipantStatus["ACCEPTED"] = "ACCEPTED";
    FriendChallengeParticipantStatus["DECLINED"] = "DECLINED";
})(FriendChallengeParticipantStatus || (FriendChallengeParticipantStatus = {}));
